// extracted by mini-css-extract-plugin
export default {"span2":"Loader_span2__qmYx5","span":"Loader_span__e5XPk","typing_loader":"Loader_typing_loader__URIMd","typing":"Loader_typing__D1Iyw"};